export default __webpack_public_path__ + "static/program-circle-renewed-en-9616c4166f5d9ec441642c4d34914344.svg";